// extracted by mini-css-extract-plugin
var _1 = "ApplicantDocumentChecklistRow-moduledivider__iNbN8 Divider-moduleDivider__dL3Vg";
var _2 = "ApplicantDocumentChecklistRow-modulestatus___bFXE";
export { _1 as "divider", _2 as "status" }
